export default "__VITE_ASSET__D9A6jrPu__"